import axios from "axios";
import { createApiResponse, createErrorApiResponse } from "../../shared/api/axiosHelper";
import { ApiResponse } from "../../shared/api/types";
import { getBackendBaseUrl } from "../../shared/variables";
import { User, UserPermissions } from "./identityApi.types";

const baseUri = getBackendBaseUrl("reporting");

const getPermissions = async () => {
  const { data } = await axios.get<ApiResponse<UserPermissions>>(`${baseUri}/Users/current/permissions`);
  return data;
};

const loadUser = async (): Promise<ApiResponse<User>> => {
  const permissionsResponse = await getPermissions();
  if (!permissionsResponse.success) {
    return createErrorApiResponse(permissionsResponse.error);
  }
  return createApiResponse(permissionsResponse.data as User);
};

export { loadUser };
